import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { FlowDownstreamFlowsQueryVariables, FlowDownstreamFlowsQuery, FlowDownstreamFlowsFilteredByFlowOutputFieldQueryVariables, FlowDownstreamFlowsFilteredByFlowOutputFieldQuery, FlowSortOrder , FlowDownstreamFlowsFilteredByFlowOutputFieldDocument , FlowDownstreamFlowsDocument } from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import {
  FlowsDisplayGrid,
  FlowsDisplayGridRowData,
  getRowDataForFlow,
} from '../sharedDisplayGrid/FlowsDisplayGrid';
import { FlowsValidSortFields } from '../sorting/sortProviders/FlowsGridSortProvider';

type QueryVariables = FlowDownstreamFlowsQueryVariables;
type QueryResults = FlowDownstreamFlowsQuery;
type QueryResultListNode = FlowsDisplayGridRowData;
type GridRowData = FlowsDisplayGridRowData;

type QueryVariablesWithFilter = FlowDownstreamFlowsFilteredByFlowOutputFieldQueryVariables;
type QueryResultsWithFilter = FlowDownstreamFlowsFilteredByFlowOutputFieldQuery;
type QueryResultListNodeWithFilter = FlowsDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  return flow ? flow.downstreamFlowsConnection : null;
}


function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  const flowOutputFields = flow && flow.outputFieldsConnection && flow.outputFieldsConnection.nodes;
  const field = flowOutputFields && flowOutputFields[0];
  return field ? field.downstreamFlowsConnection : null;
}

export type FlowDownstreamFlowsQueryGridProps = GridSortProps<FlowsValidSortFields> & {
  readonly flowVizportalUrlId: string;
  readonly filteredFlowOutputFieldId: string | null;
  readonly rowCount: number | null;
};

export function FlowDownstreamFlowsQueryGrid(props: FlowDownstreamFlowsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamFlowsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredFlowsLineageGridMessage();

  return (
    props.filteredFlowOutputFieldId ? (
      // Query with Selected Field as Filter
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={FlowDownstreamFlowsFilteredByFlowOutputFieldDocument}
        partialQueryVariables={{
          flowVizportalUrlId: props.flowVizportalUrlId,
          selectedFlowOutputFieldId: props.filteredFlowOutputFieldId,
          orderBy: props.orderBy as FlowSortOrder,
        }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) => (
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyFilteredGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        )}
      </PaginatedQueryWrapper>
    ) : (
      // Query without Selection
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={FlowDownstreamFlowsDocument}
        partialQueryVariables={{
          flowVizportalUrlId: props.flowVizportalUrlId,
          orderBy: props.orderBy as FlowSortOrder,
        }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) => (
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        )}
      </PaginatedQueryWrapper>
    )
  )
}
